import * as moment from 'moment';
import * as _ from 'lodash';
import apiService from '../../../../../service/apiService';
import logUtils from '../../../../../HelperMethods/LogUtils';

export const types = {
  LOADING_ALL_RUN_ENGINE_HISTORY: 'LOADING_ALL_RUN_ENGINE_HISTORY',
  LOADED_ALL_RUN_ENGINE_HISTORY_SUCCESSFULLY: 'LOADED_ALL_RUN_ENGINE_HISTORY_SUCCESSFULLY',
  LOADING_ALL_RUN_ENGINE_HISTORY_FAILED: 'LOADING_ALL_RUN_ENGINE_HISTORY_FAILED',
  LOAD_ALL_LOGS_PAGE_VIEW: 'LOAD_ALL_LOGS_PAGE_VIEW',
  LOAD_SINGLE_LOG_PAGE_VIEW: 'LOAD_SINGLE_LOG_PAGE_VIEW',
  LOAD_ENGINE_RERUN: 'LOAD_ENGINE_RERUN',
  RERUN_ENGINE_SUCCESS: 'RERUN_ENGINE_SUCCESS',
  RERUN_ENGINE_FAILED: 'RERUN_ENGINE_FAILED',
};

export function loadRunEngineHistoryForFieldId(fieldId) {
  return async (dispatch) => {
    dispatch({ type: types.LOADING_ALL_RUN_ENGINE_HISTORY });
    try {
      const startDate = moment().subtract(15, 'day').startOf('day').toISOString();
      const response = await apiService.getRouteEngineHistoryForFieldId(fieldId, startDate);
      const { items } = response.data.getRouteEngineHistoryByField;
      let userIds = items
        .map((item) => {
          item.data = item.data ? JSON.parse(item.data) : {};
          return _.get(item, 'data.eventInput.userId');
        })
        .filter((userId) => !!userId);
      userIds = Array.from(new Set(userIds));
      let users = [];
      if (userIds && userIds.length > 0) {
        const userResponse = await apiService.getUsersByIDs(userIds);
        users = userResponse.data.getUserByIds;
      }

      dispatch({ type: types.LOADED_ALL_RUN_ENGINE_HISTORY_SUCCESSFULLY, response, users });
    } catch (e) {
      logUtils.logError(e, 'Loading Engine Log Failed');
      dispatch({ type: types.LOADING_ALL_RUN_ENGINE_HISTORY_FAILED });
    }
  };
}

export function loadAllLogsView() {
  return (dispatch) => {
    dispatch({ type: types.LOAD_ALL_LOGS_PAGE_VIEW });
  };
}

export function loadRouteEngineData(routeEngineData) {
  return (dispatch) => {
    dispatch({ type: types.LOAD_SINGLE_LOG_PAGE_VIEW, routeEngineData });
  };
}
